<template>
  <svg class="stroke-current w-8 h-8 mr-1 md:mr-3" viewBox="0 0 34.7 27.8" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linejoin="round"><path d="m13.9.79c-9.9-1.79-13.4 5.83-13.4 5.83s3.5 7.67 13.4 5.83 13.57-5.83 13.57-5.83-3.66-3.99-13.57-5.83z"/><path d="m12.15.46a8.76 8.76 0 0 1 0 12.33"/><circle cx="7.65" cy="5.34" r="1.47"/><path d="m34.2 1.13h-2.2a3.8 3.8 0 0 0 -3.65 2.7l-.86 2.79h2.16a3.84 3.84 0 0 0 3.62-2.62z"/><path d="m27.47 6.62h2.21a3.83 3.83 0 0 1 3.66 2.7l.86 2.79h-2.2a3.82 3.82 0 0 1 -3.64-2.65z"/><path d="m20.8 15.36c9.9-1.84 13.4 5.83 13.4 5.83s-3.5 7.67-13.4 5.81-13.56-5.81-13.56-5.81 3.65-3.99 13.56-5.83z"/><path d="m22.55 15.07a8.76 8.76 0 0 0 0 12.33"/><circle cx="27.05" cy="19.91" r="1.47"/><path d="m.5 15.7h2.22a3.82 3.82 0 0 1 3.66 2.7l.86 2.79h-2.17a3.84 3.84 0 0 1 -3.64-2.64z"/><path d="m7.24 21.19h-2.24a3.83 3.83 0 0 0 -3.66 2.7l-.84 2.79h2.13a3.83 3.83 0 0 0 3.64-2.68z"/></g></svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
